// import React from 'react';
// import { Box } from '@chakra-ui/react';

// interface JaggedBorderProps {
//   bgColor?: string;
// }

// export const JaggedBorderFooter: React.FC<JaggedBorderProps> = ({ bgColor = 'white' }) => {
//   return (
//     // <Box width="100%" height="100px" position="relative" bottom="0" overflow="hidden">
//     // <Box width="100%" height="190px" position="relative" bottom="0" overflow="hidden" zIndex="1">
//     <Box
//       width="100%"
//       height="140px"
//       position="relative"
//       overflow="hidden"
//       lineHeight="0"
//       // borderBottom={`10px solid ${bgColor}`}
//     >
//       <Box
//         position="absolute"
//         top="0"
//         left="50%"
//         height="100%"
//         zIndex={1}
//         transform="translateX(-50%)"
//         minWidth="1920px"
//       >
//         {/* Gradient Stroke Path */}
//         <svg
//           viewBox="0 0 1920 120"
//           width="100%"
//           height="100%"
//           preserveAspectRatio="none"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <defs>
//             <linearGradient
//               id="jagged-gradient"
//               x1="-41"
//               y1="59.7849"
//               x2="1956"
//               y2="59.7849"
//               gradientUnits="userSpaceOnUse"
//             >
//               <stop stopColor="#4371D4" />
//               <stop offset="0.201923" stopColor="#8934C4" />
//               <stop offset="0.495192" stopColor="#3D99E0" />
//               <stop offset="0.8" stopColor="#8934C4" />
//               <stop offset="1" stopColor="#4272D4" />
//             </linearGradient>
//           </defs>
//           <path
//             d="M-41 60.8198L110.019 70.7598L164.015 52.5298L137.861 105.57L320.152 34L379.713 56L365.459 14L498.114 67.4502L469.818 21L746.156 69.1099L817.029 26.02L803.529 84.02L936.126 55L975.64 90.6499L1160.63 52L1184.87 75.7402L1240.04 51L1230.43 93.9702L1346.02 82.3599L1411.83 57.5098L1438.82 80.71L1579.08 58L1632.53 77L1707.37 42L1657.48 97L1859.07 54L1956 75.7402"
//             stroke="url(#jagged-gradient)"
//             strokeWidth="15"
//             strokeMiterlimit="7.6613"
//             fill="none"
//           />
//         </svg>
//       </Box>

//       {/* Bg Fill */}
//       <Box
//         position="absolute"
//         top="0"
//         left="50%"
//         height="100%"
//         zIndex={2}
//         transform="translateX(-50%)"
//         minWidth="1920px"
//       >
//         <svg
//           viewBox="0 0 1920 120"
//           width="100%"
//           height="100%"
//           preserveAspectRatio="none"
//           xmlns="http://www.w3.org/2000/svg"
//           shapeRendering="crispEdges"
//         >
//           <path
//             d="M-41 60.8198L110.019 70.7598L164.015 52.5298L137.861 105.57L320.152 34L379.713 56L365.459 14L498.114 67.4502L469.818 21L746.156 69.1099L817.029 26.02L803.529 84.02L936.126 55L975.64 90.6499L1160.63 52L1184.87 75.7402L1240.04 51L1230.43 93.9702L1346.02 82.3599L1411.83 57.5098L1438.82 80.71L1579.08 58L1632.53 77L1707.37 42L1657.48 97L1859.07 54L1956 75.7402L1956 122 L-41 122Z"
//             fill={bgColor}
//           />
//         </svg>
//       </Box>
//     </Box>
//   );
// };
import React from 'react';
import { Box, useBreakpointValue } from '@chakra-ui/react';

interface JaggedBorderProps {
  bgColor?: string;
}

export const JaggedBorderFooter: React.FC<JaggedBorderProps> = ({ bgColor = 'white' }) => {
  const responsiveWidth = useBreakpointValue({
    base: '1920px', // crop on small screens
    xl: '100%', // stretch on large screens
  });
  return (
    <Box width="100%" height="140px" position="relative" overflow="hidden" lineHeight="0">
      <Box
        position="absolute"
        height="100%"
        zIndex={1}
        top="0"
        right="0"
        left="auto"
        width={responsiveWidth}
      >
        {/* Gradient Stroke Path */}
        <svg
          viewBox="0 0 1920 120"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              id="jagged-gradient"
              x1="-41"
              y1="59.7849"
              x2="1956"
              y2="59.7849"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4371D4" />
              <stop offset="0.201923" stopColor="#8934C4" />
              <stop offset="0.495192" stopColor="#3D99E0" />
              <stop offset="0.8" stopColor="#8934C4" />
              <stop offset="1" stopColor="#4272D4" />
            </linearGradient>
          </defs>
          <path
            d="M-41 60.8198L110.019 70.7598L164.015 52.5298L137.861 105.57L320.152 34L379.713 56L365.459 14L498.114 67.4502L469.818 21L746.156 69.1099L817.029 26.02L803.529 84.02L936.126 55L975.64 90.6499L1160.63 52L1184.87 75.7402L1240.04 51L1230.43 93.9702L1346.02 82.3599L1411.83 57.5098L1438.82 80.71L1579.08 58L1632.53 77L1707.37 42L1657.48 97L1859.07 54L1956 75.7402"
            stroke="url(#jagged-gradient)"
            strokeWidth="15"
            strokeMiterlimit="7.6613"
            fill="none"
          />
        </svg>
      </Box>

      {/* Bg Fill */}
      <Box
        position="absolute"
        height="100%"
        zIndex={2}
        top="0"
        right="0"
        left="auto"
        width={responsiveWidth}
      >
        <svg
          viewBox="0 0 1920 120"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          shapeRendering="crispEdges"
        >
          <path
            d="M-41 60.8198L110.019 70.7598L164.015 52.5298L137.861 105.57L320.152 34L379.713 56L365.459 14L498.114 67.4502L469.818 21L746.156 69.1099L817.029 26.02L803.529 84.02L936.126 55L975.64 90.6499L1160.63 52L1184.87 75.7402L1240.04 51L1230.43 93.9702L1346.02 82.3599L1411.83 57.5098L1438.82 80.71L1579.08 58L1632.53 77L1707.37 42L1657.48 97L1859.07 54L1956 75.7402L1956 122 L-41 122Z"
            fill={bgColor}
          />
        </svg>
      </Box>
    </Box>
  );
};
